export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-bold font-heading text-primary-400">17黑料网</span>
              <p className="text-sm text-white/50 mt-3 leading-relaxed">
                17黑料网致力于为全网用户提供最新、最全的国产黑料内容在线观看服务。
                整合国产黑料视频、黑料吃瓜资讯及热门话题讨论，打造优质的国产黑料一区内容平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4 font-heading">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#updates" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
                <a href="#topics" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
                <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
                <a href="#cards" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">图文资讯</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4 font-heading">关于我们</h4>
              <div className="flex flex-col gap-2">
                <a href="#about" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">平台介绍</a>
                <a href="#contact" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
                <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
                <a href="#comments" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer">吃瓜评论</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white/80 mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-white/40 leading-relaxed">
                更多优质合作伙伴正在加入中，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/30">
              &copy; 2026 17黑料网 - 17c国产一区二区黑料在线观看。仅供信息展示，不存储任何视频文件。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-white/30">国产黑料视频一区高清播放</span>
              <span className="text-xs text-white/30">黑料视频在线资源平台</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}